// extracted by mini-css-extract-plugin
module.exports = {"root":"Preloader_root__yEnWw","opened":"Preloader_opened__NoLhP","container":"Preloader_container__gZArl","loader":"Preloader_loader__Li21g"};